import type { RequireExactlyOne } from 'type-fest';

export type WebsocketNamespace = RequireExactlyOne<{
    companyId: string;
    userId: string;
    workspaceId: string;
    broadcast: 'all';
}>;

const WebsocketNamespaceKeys: Record<keyof WebsocketNamespace, string> = {
    companyId: 'company',
    userId: 'user',
    workspaceId: 'workspace',
    broadcast: 'broadcast'
};

export const getNamespaceParts = (namespace: WebsocketNamespace) => {
    const namespaceValueKey = Object.keys(namespace)[0];
    const namespaceName = WebsocketNamespaceKeys[namespaceValueKey];
    const namespaceId = namespace[namespaceValueKey];

    return {
        namespaceName,
        namespaceId
    };
};

export const buildTopic = ({
    namespace,
    roomName
}: {
    namespace: WebsocketNamespace;
    roomName: string;
}) => {
    const { namespaceName, namespaceId } = getNamespaceParts(namespace);

    return `${namespaceName}.${namespaceId}.${roomName}`;
};
